'use client';

import { PopoverStyledButton } from '@components/common/Popover/PopoverStyled';
import { cn } from '@utils/cn';
import type { ActionItem } from './usePromptBarActions';
import type { MissionNavItem } from './useMissionNavItems';

interface PromptBarActionsListProps {
  items: MissionNavItem[];
  onItemClick: (item: ActionItem) => void;
}

/**
 * Shared `<ul>` of mission items rendered inside every prompt-bar navigation panel.
 * Mirrors the nav layout (Jobs / Coach / Talents / MyJobs+) — one flat list, labels
 * come from useMissionNavItems, not from the raw ActionItem.
 */
export const PromptBarActionsList = ({ items, onItemClick }: PromptBarActionsListProps) => (
  <ul role="menu" className="flex flex-col">
    {items.map(({ item, label }) => (
      <li key={item.key}>
        <PopoverStyledButton
          as="button"
          type="button"
          role="menuitem"
          aria-current={item.selected ? 'page' : undefined}
          onClick={() => onItemClick(item)}
          className={cn(
            'flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm',
            item.selected
              ? 'cursor-default text-ink/40'
              : 'text-ink hover:bg-surface-100',
          )}
        >
          {label}
        </PopoverStyledButton>
      </li>
    ))}
  </ul>
);
